import React, { useContext } from 'react';
import { createContext } from 'react';

import { CommentableType } from '@utils/backend-api/comments';

type CommentsContextType = {
  rootCommentableId: number;
  rootCommentableType: CommentableType;
};

const AppContext = createContext<CommentsContextType>({
  rootCommentableId: undefined,
  rootCommentableType: undefined,
});

export const CommentsContextProvider = ({
  rootCommentableId,
  rootCommentableType,
  children,
}: {
  rootCommentableId: number;
  rootCommentableType: CommentableType;
  children: React.ReactNode;
}) => {
  const value = { rootCommentableId, rootCommentableType };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useCommentsContext = () => {
  const context = useContext(AppContext);
  return context;
};
